export default __webpack_public_path__ + "img/acedf143d342394a91682b34e85a4b09.svg";